// assets
import { IconBuildingStore, IconChartBar, IconFileText, IconMail, IconNotes, IconUsers, IconUsersGroup } from '@tabler/icons-react';

import { DESIGN_SYSTEM_COMPONENTS, DesignSystemComponent } from '../constant/designSystem';
import { NavItemType } from '../types';
import { getStaffAclNavChildren } from './aclNav';

// constant
const icons = {
    IconUsers,
    IconChartBar,
    IconBuildingStore,
    IconUsersGroup,
    IconNotes,
    IconMail,
    IconFileText
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

type OtherMenuOptions = {
    hideWeekendHandoff?: boolean;
    showHandoff?: boolean;
    showPatients?: boolean;
    showCensus?: boolean;
    showSupervisorScorecard?: boolean;
    showInsights?: boolean;
    showEscalationDashboard?: boolean;
    showDartReport?: boolean;
    showStaticSubscribers?: boolean;
    showMeetingTranscription?: boolean;
    showProgressNotes?: boolean;
    showManageStaff?: boolean;
    showAcl?: boolean;
};

export const getOtherMenu = ({
    showHandoff = false,
    showPatients = false,
    showCensus = false,
    showInsights = false,
    showEscalationDashboard = false,
    showSupervisorScorecard = false,
    showDartReport = false,
    showStaticSubscribers = false,
    showMeetingTranscription = false,
    showProgressNotes = false,
    showManageStaff = false,
    showAcl = false
}: OtherMenuOptions = {}): NavItemType => ({
    id: 'staff-nav-items',
    icon: IconUsers,
    type: 'group',
    children: [
        ...(showCensus
            ? [
                  {
                      id: 'census',
                      title: 'Census',
                      type: 'item',
                      url: '/census',
                      icon: icons.IconChartBar,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showHandoff
            ? [
                  {
                      id: 'handoff',
                      title: 'Handoff',
                      type: 'item',
                      url: '/dashboard',
                      icon: icons.IconChartBar,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showInsights
            ? [
                  {
                      id: 'Insights',
                      title: 'Insights',
                      type: 'item',
                      url: '/insights',
                      icon: icons.IconChartBar,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showEscalationDashboard
            ? [
                  {
                      id: 'escalation-dashboard',
                      title: 'Escalation Dashboard',
                      type: 'item',
                      url: '/escalation-dashboard',
                      icon: icons.IconChartBar,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showPatients
            ? [
                  {
                      id: 'patients',
                      title: 'Patients',
                      type: 'item',
                      url: '/patients',
                      icon: icons.IconUsers,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showDartReport
            ? [
                  {
                      id: 'dart-report',
                      title: 'DARt',
                      caption: 'Discharge Acceleration Report',
                      type: 'item',
                      url: '/dart-report',
                      icon: icons.IconChartBar,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showProgressNotes
            ? [
                  {
                      id: 'my-patients',
                      title: 'CCM',
                      caption: 'Complex Case Management',
                      type: 'item',
                      url: '/my-patients',
                      icon: icons.IconNotes,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showStaticSubscribers
            ? [
                  {
                      id: 'static-subscribers',
                      title: 'Static Subscribers',
                      type: 'item',
                      url: '/static-subscribers',
                      icon: icons.IconMail,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showMeetingTranscription
            ? [
                  {
                      id: 'meeting-transcription',
                      title: 'Meeting Transcription',
                      type: 'item',
                      url: '/meeting-transcription',
                      icon: icons.IconFileText,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showSupervisorScorecard
            ? [
                  {
                      id: 'supervisor-scorecard',
                      title: 'Performance Scorecard',
                      type: 'item',
                      url: '/supervisor/scorecard',
                      icon: icons.IconUsersGroup,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...(showManageStaff
            ? [
                  {
                      id: 'manage-staff',
                      title: 'Manage Staff',
                      type: 'item',
                      url: '/manage-staff',
                      icon: icons.IconUsers,
                      breadcrumbs: false
                  }
              ]
            : []),
        ...getStaffAclNavChildren(showAcl),

        ...(process.env.NODE_ENV === 'development'
            ? [
                  {
                      id: 'design-system',
                      title: 'Design System',
                      type: 'collapse',
                      icon: icons.IconChartBar,
                      children: DESIGN_SYSTEM_COMPONENTS.map((component: DesignSystemComponent) => ({
                          id: `design-system-${component.id}`,
                          title: component.title,
                          type: 'item',
                          url: component.path,
                          breadcrumbs: true
                      }))
                  }
              ]
            : [])
    ]
});

const other: NavItemType = getOtherMenu();

export default other;
